import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/pdf-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-5629199d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closed-obligations__card" }
const _hoisted_2 = { class: "closed-obligations__card-title" }
const _hoisted_3 = { class: "closed-obligations__card-header" }
const _hoisted_4 = { class: "closed-obligations__card-span-bold" }
const _hoisted_5 = { class: "closed-obligations__card-date-agree-total-value" }
const _hoisted_6 = { class: "closed-obligations__card-grid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "closed-obligations__card-span-title" }, "Fecha", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "closed-obligations__card-span-bold" }
const _hoisted_10 = { class: "closed-obligations__card-grid" }
const _hoisted_11 = { class: "closed-obligations__card-span-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "closed-obligations__card-span-bold" }
const _hoisted_14 = { class: "closed-obligations__card-date-agree-total-value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "closed-obligations__card-span-title" }, " Valor total de la obligación ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "closed-obligations__card-span-bold" }
const _hoisted_18 = { class: "closed-obligations__card-button-container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "inline-flex fill-current text-white",
  src: _imports_0,
  alt: "descargar paz y salvo"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.obligation?.commerce_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.formatDate(new Date(_ctx.obligation?.date_obligation))), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, " Número de " + _toDisplayString(_ctx.obligation.lince ? 'obligación' : 'acuerdo'), 1),
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.obligation?.id), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$filters.currency(_ctx.obligation?.value ? _ctx.obligation?.value : '0')), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        type: "submit",
        class: "closed-obligations__card-button font-bold",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadDocument && _ctx.downloadDocument(...args)))
      }, [
        _hoisted_19,
        _createTextVNode(" Generar Paz y Salvo ")
      ])
    ])
  ]))
}